import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { TASK_CATEGORY_API } from "../apiRoutes";

const mutateAddTaskCategory = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${TASK_CATEGORY_API}`, data);
};

const useAddTaskCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddTaskCategory,
    ...queryParams,
  });

export default useAddTaskCategoryMutation;
